enum PinLegendType {
  COLOR = "color",
  SHAPE = "shape",
}

export default PinLegendType;
